import { load } from '../service/itinerary';

export default function( $, app ) {
	var $profile = $( '#profile' );
	var $save = $( '#save_itinerary' );
	var $share = $( '#share_itinerary' );
	var $mapit = $( '.map-itinerary' );

	var {
		model: session,
		views: {
			tripsList: {
				collection: myTrips,
			},
		},
	} = app;

	$profile
	.on( 'showing', () => {
		load( session.get( 'uid' ), data => {
			var trips = data.trips || [];
			myTrips.reset( trips.map( trip => ( {
				id: trip.tripID,
				type: trip.tripType,
				title: trip.tripName,
				origin: trip.tripFrom,
				destination: trip.tripTo,
				date: trip.tripDate,
				start: trip.tripTime,
				mode: trip.tripMode,
				stops: trip.tripStops,
			} ) ) );
		} );
	} )

	$save
	.on( 'submit', function( e ) {
		e.preventDefault();

		flutterDebug( 'save itinerary', session );

		session.set( 'title', document.getElementById( 'trip_name' ).value );
		session.save( () => {
			this.reset();
			history.back();
		} );
	} );

	var $shareUrl = $( '#share_url' );
	$share.on( 'showing', () => {
		session.save( () => {
			var url = window.location.origin + '#itinerary/' + session.id;

			flutterDebug( 'share', url );
			flutterDebug( 'sharesupport', !! navigator.share );

			if ( navigator.share ) {
				navigator.share( {
					title: 'My Flutterbout Itinerary',
					url,
				} );
			}

			$shareUrl.val( url );
		} );
	} );

	$( '.-share' ).click( () => {
		navigator.share( {
			title: 'My Flutterbout Itinerary',
			url: $shareUrl.val(),
		} );
	} ).toggleClass( 'hidden', typeof navigator.share === 'undefined' );

	$mapit.click( function() {
		var url = 'https://www.google.com/maps/dir/';

		var stops = [ session.get( 'origin' ) ];

		session.stops.each( stop => {
			stops.push( stop.getPosition( 'as string' ) );
		} );

		stops.push( session.get( 'destination' ) );

		url += stops.map( value => encodeURIComponent( value ) ).join( '/' );

		window.open( url );
	} );
}
